import { Localized } from '~/i18n';
import ScalekitLogo from '~/assets/scalekit-logo-dark.svg';
import { mergeProps } from 'solid-js';
import { twMerge } from 'tailwind-merge';
import Link from '../Link';
import { externalLinks } from '~/consts';

type ScalekitWatermarkProps = {
  class?: string;
};

export default function ScalekitWatermark(props: ScalekitWatermarkProps) {
  const merged = mergeProps({}, props);
  return (
    <div
      class={twMerge(
        'flex justify-center bg-bg-subtle w-full p-2',
        merged.class
      )}
    >
      <Link
        href={externalLinks.scalekitWebsiteUrl}
        target="_blank"
        class="flex items-center justify-center gap-1 max-w-fit"
        rel="noopener noreferrer"
      >
        <span class="text-xs text-fg-subtle">
          <Localized translationKey="commons.scalekit_watermark.text" />
        </span>
        <img
          class={`w-[56px] mb-px`}
          src={ScalekitLogo}
          alt={'Scalekit'}
        />
      </Link>
    </div>
  );
}
